import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import './index.css';

import store from './store';
import ErrorBoundary from './services/ErrorBoundary';
import App from './components/App';

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ReactNotifications />
      <App />
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);
